export default __webpack_public_path__ + "static/media/Group 3379.0c343d8f.png";